import { APPLICATION_INITIALIZED } from "./actions";

/* application is initialized  */
export const applicationInitialized = () => ({
    type: APPLICATION_INITIALIZED
})



// WEBPACK FOOTER //
// ./src/store/modules/application/actionCreators.ts